module.exports = __webpack_public_path__ + "img/scg_logo.6fe2a725.png";